<template>
  <div class="main-email-wrapper">
    <div class="blur"></div>
    <div class="wrapper">
      <div class="pop-up-mail">
        <div class="mail-main-close-btn" @click="$emit('close')"><v-icon >mdi-close</v-icon></div>

        <div class="upper-line">
          
          <div class="upper-line-left">
            <div class="mail-pop-up-title">{{ $t('components.email.fetcher.title') }}</div>
            <div class="mail-subtitle-doc-line">
              <div class="mail-subtitle">
                {{ $t('components.email.fetcher.subtitle') }}
              </div>
              <!-- <div class="mail-doc-txt-no">
                <div class="mail-doc-txt">Odabrani broj dokumenata:</div>
                <div class="mail-doc-no">2</div>
              </div> -->
            </div>
          </div>
          
          <div class="upper-line-right">

            <!-- <div class="scale-notifications-icon-wrapper">
              <div class="scale-notifications-icon">
                <img src="@/assets/img/email/vaga.svg" />
              </div>
              <div class="scale-notifications-counter">4</div>
            </div>
            <div class="mail-search">
              <input type="text" v-model="search_text" @keyup.enter="activateGeneralSearch()" class="mail-search-line">
              <div class="mail-search-icon" @click="activateGeneralSearch()">
                <img src="@/assets/img/email/povecalo.svg" />
              </div>
            </div> -->
            <v-text-field
              class="input-prepend-apend"
              v-model="search_text"
              :label="$t('components.email.fetcher.search')"
              :disabled="active_case_filter"
              @keyup.enter="activateGeneralSearch()"
            >
              <template v-slot:prepend>
                <div
                  class="scale-notifications-icon-wrapper"
                  v-if="is_case_visible"
                  :class="[active_case_filter ? 'active' : '']"
                  @click="activateCaseFilter()"
                >
                  <div class="scale-notifications-icon">
                    <svg
                      id="Layer_2"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 57.63 56.27"
                    >
                      <defs></defs>
                      <g id="Layer_1-2">
                        <path
                          class="cls-1"
                          d="M57.41,29.97c-1.14-4.83-8.8-12.18-9.45-13.1l-9.47-9.35h-7.96v-2.78s0-2.91,0-2.91c0-.87-.59-1.67-1.45-1.81-1.09-.18-2.04.66-2.04,1.72v5.78s-7.42,0-7.42,0l-9.91,9.35c-.66.92-8.58,8.31-9.7,13.19v.03l.03,1.75c.08,5.13,5.06,9.3,11.09,9.3s11.09-4.23,11.09-9.42v-1.74h-.22c-.94-3.97-7.06-9.62-8.71-12.02.12-.06.23-.14.34-.23l7.35-6.71h6.07v34.27h-3.31c-3.53,0-6.38,2.86-6.38,6.38v1.12h-1.07c-.96,0-1.74.78-1.74,1.74,0,.04,0,.09.01.13h0v1.61h28.06v-1.61h-.01s.01-.09.01-.13c0-.96-.78-1.74-1.74-1.74h-.66v-1.1c0-3.54-2.87-6.41-6.41-6.41h-3.27V11.01h6.52l6.61,6.57c.2.2.29.55.54.63-1.66,2.44-7.6,7.87-8.51,11.86l-.27.03.03,1.75c.08,5.13,5.06,9.3,11.09,9.3s11.09-4.23,11.09-9.42v-1.74h-.22ZM11.12,37.65c-3.36,0-6.25-1.73-7.24-4.12l7.25-.08h7.25c-.98,2.4-3.91,4.19-7.26,4.19ZM18.38,29.9l-7.27.07H3.61c.81-2.5,5.64-6.14,7.51-8.99,1.86,2.84,6.43,6.45,7.26,8.92ZM33.79,48.77c1.61,0,2.92,1.31,2.92,2.92v1.1h-15.88v-1.12c0-1.6,1.3-2.9,2.9-2.9h10.06ZM46.54,20.98c1.86,2.84,6.43,6.45,7.26,8.92l-7.27.07h-7.23c.81-2.5,5.36-6.14,7.24-8.99ZM46.54,37.65c-3.36,0-6.25-1.73-7.24-4.12l7.25-.08h7.25c-.98,2.4-3.91,4.19-7.26,4.19Z"
                        />
                      </g>
                    </svg>
                  </div>
                  <!-- <div class="scale-notifications-counter">4</div> -->
                </div>
              </template>
              <template v-slot:append-outer>
                <div
                  class="mail-search-icon"
                  :class="[active_case_filter ? 'disabled' : '']"
                  @click="activateGeneralSearch()"
                >
                  <img src="@/assets/img/email/povecalo.svg" />
                </div> </template
            ></v-text-field>
          </div>
        </div>
        <div class="pop-up-mail-body">
          <mail-folder-select
            :selected_folder.sync="selected_folder"
            @folderSwitch="switchFolder"
            @syncEmails="syncCurrentFolder"
          />
          <div class="mail-body-list">
            <date-picker @dateChange="dateFilterActivated" />
            <!-- <div class="mail-list-search">Odaberite period</div> -->
            <mail-list-array
              :email_arr="filtered_email_array"
              :selected_email="selected_email"
              :can_load_more="has_more_emails"
              @loadMore="proceedLoadingEmails"
              @setActiveEmail="setActiveEmail"
              :is_loading="loading_flag"
            />
          </div>
          <mail-body-content
            :is_loading="loading_flag"
            :selected_email="selected_email"
            :folder="this.selected_folder"
            :is_empty_folder="this.filtered_email_array.length == 0"
          />
          <div v-if="selected_email" class="page-count-info">
            <div class="page-count-line">
              {{ $t('components.email.main.page_count.label') }}
              <select 
                v-model="selected_page_count"
                class="page-count-dropdown"
              >
                <option 
                  v-for="n in estimated_page_count" 
                  :key="n" 
                  :value="n"
                >
                  {{ n }}
                </option>
              </select>
              {{ $t('components.email.main.page_count.of') }} {{ estimated_page_count }}
            </div>
          </div>
          <mail-activity-right
            @activitySetup="selectActivity"
            :selected_email="selected_email"
          />
        </div>
        <final-email-response
          ref="emailDialog"
          :key="refreshNewEmail"
          @successfull="successfullySentEmail"
        />
        <email-expanded-file-reader ref="mainAttachmentViewer" />

        <folder-select-modal
          :file_to_copy="[]"
          ref="folderSelectModal"
          @folderSelected="handleMailSave"
        />
        <!-- Invisible A4 measurement div -->
        <div class="a4-measurement" ref="a4Measurement" v-if="selected_email" v-html="selected_email.email.body.content"></div>
      </div>
    </div>
    <!-- <final-email-response ref="emailDialog"/> -->
  </div>
</template>

<script>
import ms_email from "../../apiCallers/promise_handler_db/ms_email";
import graph from "../../services/graph";

import MailFolderSelect from "./components/mail-client-firmwide/MailFolderSelect.vue";
import {
  getFolderEmails,
  searchGraphMessages,
} from "../../apiCallers/graph/email/email.getters";
import {
  getEmailWithAttachments,
  constructCaseFolderSearchQuery,
  constructCaseSearchQuery,
  mapSearchApiResponse,
} from "../../helpers/email/index";
import MailListArray from "./components/mail-client-firmwide/MailListArray.vue";
import MailActivityRight from "./components/mail-client-firmwide/MailActivityRight.vue";
import MailBodyContent from "./components/mail-client-firmwide/MailBodyContent.vue";
import FinalEmailResponse from "./FinalEmailResponse.vue";
import DatePicker from "../generalComponents/DatePicker.vue";
import moment from "moment";
import FolderSelectModal from "../fileManagement/FolderSelectModal.vue";
import EmailExpandedFileReader from "./file-management/EmailExpandedFileReader.vue";
import { showGlobalLoader, hideGlobalLoader } from "../../helpers/loader/global";
export default {
  components: {
    MailFolderSelect,
    MailListArray,
    MailActivityRight,
    MailBodyContent,
    FinalEmailResponse,
    DatePicker,
    FolderSelectModal,
    EmailExpandedFileReader,
  },
  data() {
    return {
      //SINGLETON VALUES
      selected_folder: "Inbox",
      selected_email: null,
      next_link: null,
      // Situations in which case the user is not able
      take_number: 25,
      from_starter: 0,
      count_all_emails: 0,
      refreshNewEmail : 1,
      estimated_page_count: 0,
      selected_page_count: 0,

      // QUERY PARAMS

      search_text: "",
      date_search_text: "",
      date_range: [],
      final_search_query: "orderby=receivedDateTime desc&$top=50",
      default_search_query: "orderby=receivedDateTime desc&$top=50",

      //ARRAYS
      retrieved_email_array: [],
      filtered_email_array: [],

      //FLAGS

      active_case_filter: false,
      loading_flag: false,

      // ABORT CONTROLLERS (for cancelling pending requests)
      emailFetchController: null,
      folderFetchController: null,
    };
  },

  computed: {
    is_case_visible() {
      var user = this.$store.state.logged_in_user;
      if (!user || !user.case_activity || user.case_activity.length === 0) {
        return null;
      }
      return user.case_activity[0] && user.case_activity[0].predmet ? user.case_activity[0].predmet : null;
    },
    has_more_emails() {
      if (this.selected_folder == "all") {
        return this.count_all_emails > this.from_starter;
      } else {
        return (
          this.filtered_email_array.length ==
            this.retrieved_email_array.length && this.next_link != null
        );
      }
    },
  },

  methods: {
    attachmentList(att_list) {
      att_list = att_list.map((p) => p.name);
      return att_list.join(", ");
    },
    prepareExportMail() {
      let tmp_mail = this.selected_email.email;
      tmp_mail["attachment_text"] = "";
      if (this.selected_email.attachments.length > 0) {
        tmp_mail["attachment_text"] =
          this.$t("components.pregled_poste.part_of_doc") +
          this.attachmentList(this.selected_email.attachments);
      }
      return tmp_mail;
    },
    async handleMailSave(folder_selected) {
      const tmp_mail = this.prepareExportMail();
      showGlobalLoader(this.$t('components.email.main.saving_communication', { folder: folder_selected.selected_folder.name }));
      try {
        await ms_email.saveEmail(
          "",
          this.selected_email.email.id,
          folder_selected.case_id,
          folder_selected.selected_folder.id,
          this.selected_page_count,
          tmp_mail
        );
        this.$toast.success(this.$t('components.email.main.save_success'));
      } catch (error) {
        this.$toast.error(this.$t('components.email.main.save_error'));
      } finally {
        hideGlobalLoader();
      }
    },
    successfullySentEmail() {
      if (
        this.selected_folder == "SentItems" ||
        this.selected_folder == "drafts"
      ) {
        showGlobalLoader(this.$t('components.email.main.sync'));
        setTimeout(() => {
          this.syncCurrentFolder();
          hideGlobalLoader();
        }, 2000);
      }
    },
    syncCurrentFolder() {
      this.switchFolder(this.selected_folder);
    },

    activateCaseFilter() {
      this.active_case_filter = !this.active_case_filter;
      this.switchFolder("all");
    },
    /**
     * Method active after change in date span.
     * @param {*} date_string
     */
    dateFilterActivated(date_val) {
      this.date_search_text = date_val.date_string;
      this.date_range = date_val.range;
      this.filterEmails();
    },

    /**
     * Method on change
     */
    activateGeneralSearch() {
      this.final_search_query = "";
      if (this.search_text) {
        this.final_search_query = "&$search=" + this.search_text + "&$top=50";
      } else {
        this.final_search_query = this.default_search_query;
      }
      this.switchFolder(this.selected_folder);
    },
    /**
     * Method that handles types of activity from right activity bar.
     * @param {*} emited_activity Emited activities in Integer values.
     */
    selectActivity(emited_activity) {
      switch (emited_activity) {
        case 1:
          this.openNewEmailDialog(this.selected_email, emited_activity);
          break;
        case 2:
          this.openNewEmailDialog(this.selected_email, emited_activity);
          break;
        case 3:
          this.openNewEmailDialog();
          break;

        case 4:
          this.$refs.mainAttachmentViewer.openDialog([
            ...this.selected_email.attachments,
          ]);
          break;
        case 5:
          this.$refs.folderSelectModal.open(1);
          break;
        case 7:
          this.openNewEmailDialog(this.selected_email, 3);
          break;
        default:
          break;
      }
    },

    /**
     * Method that opens email create/edit modal window.
     */
    openNewEmailDialog(email = null, emited_activity = 0) {
      // Opens the dialog for a new email draft
      this.refreshNewEmail +=1;
      setTimeout(()=>{
        this.$refs.emailDialog.open(email, emited_activity);
      },300)
      
    },
    /**
     * Method triggered via selection in array. Triggers further methods of data retrieval.
     * @param {*} email_id Identification of selected email
     */
    async setActiveEmail(email_id) {
      // Cancel any pending email fetch
      if (this.emailFetchController) {
        this.emailFetchController.abort();
      }
      this.emailFetchController = new AbortController();

      showGlobalLoader(this.$t('components.email.main.loading'));
      try {
        const resp = await getEmailWithAttachments(email_id);

        // Check if request was aborted
        if (this.emailFetchController.signal.aborted) {
          return;
        }

        if (this.selected_folder == "drafts") {
          this.openNewEmailDialog(resp, -1);
          this.selected_email = null;
        } else {
          this.selected_email = resp;
          // Wait for DOM to update before calculating page count
          this.$nextTick(() => {
            this.estimated_page_count = this.estimatePageCount(resp.email);
            this.selected_page_count = this.estimated_page_count;
          });

          // Mark email as read if it's unread
          const emailInArray = this.retrieved_email_array.find(e => e.id === email_id);
          if (emailInArray && !emailInArray.isRead) {
            emailInArray.isRead = true;
            try {
              await graph.markEmailAsRead(email_id);
              this.$emit('emailRead');
            } catch (markError) {
              console.error("Failed to mark email as read:", markError);
              // Revert UI state on failure
              emailInArray.isRead = false;
            }
          }
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.$toast.error(this.$t('components.email.main.fetch_email_error'));
        }
      } finally {
        hideGlobalLoader();
      }
    },
    /**
     * Method that handles switching folders inside the navigation component.
     * @param {*} selected_folder name of the selected folder that coresponds in ms-graph.
     * VOID Function
     */
    async switchFolder(selected_folder) {
      // Cancel any pending folder fetch
      if (this.folderFetchController) {
        this.folderFetchController.abort();
      }
      this.folderFetchController = new AbortController();

      this.selected_folder = selected_folder;
      this.retrieved_email_array = [];
      this.filtered_email_array = [];
      this.from_starter = 0;
      this.count_all_emails = 0;
      this.loading_flag = true;
      this.selected_email = null;

      if (selected_folder != "all") {
        this.active_case_filter = false;
      }

      if (selected_folder != "all" && !this.active_case_filter) {
        try {
          const resp = await getFolderEmails(
            null,
            this.final_search_query,
            selected_folder
          );

          // Check if request was aborted
          if (this.folderFetchController.signal.aborted) {
            return;
          }

          this.retrieved_email_array.push(...resp.value);
          this.next_link = resp["@odata.nextLink"] || null;
          this.filterEmails();
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.$toast.error(this.$t('components.email.main.fetch_error'));
          }
        } finally {
          this.loading_flag = false;
        }
      } else {
        await this.loadSearchApiEmails();
      }
    },

    filterEmails() {
      this.filtered_email_array = [...this.retrieved_email_array];

      switch (this.date_range.length) {
        case 1:
          this.filtered_email_array = this.filtered_email_array.filter(
            (p) =>
              new Date(p.createdDateTime) >=
                new Date(moment(this.date_range[0]).startOf("day").format()) &&
              new Date(p.createdDateTime) <=
                new Date(moment(this.date_range[0]).endOf("day").format())
          );
          break;

        case 2:
          this.filtered_email_array = this.filtered_email_array.filter(
            (p) =>
              new Date(p.createdDateTime) >=
                new Date(moment(this.date_range[0]).startOf("day").format()) &&
              new Date(p.createdDateTime) <=
                new Date(moment(this.date_range[1]).endOf("day").format())
          );
          break;
      }

    },

    /**
     * Method that loads next set of emails to the array.
     */
    async proceedLoadingEmails() {
      if (this.active_case_filter || this.selected_folder == "all") {
        this.loadSearchApiEmails();
      } else {
        try {
          var resp = await getFolderEmails(this.next_link, "", "");
          this.retrieved_email_array.push(...resp.value);
          this.next_link = resp["@odata.nextLink"];
          this.filterEmails();
        } catch (error) {
          this.$toast.error(this.$t('components.email.main.load_more_error'));
        }
      }
    },
    async loadSearchApiEmails() {
      // Safe access to case activity with null check
      var user = this.$store.state.logged_in_user;
      var caseActivity = user && user.case_activity ? user.case_activity : null;
      var hasCasePredmet = caseActivity && caseActivity[0] && caseActivity[0].predmet;
      var filter_text = this.active_case_filter && hasCasePredmet
        ? constructCaseSearchQuery(caseActivity[0].predmet)
        : this.search_text
        ? this.search_text.trim()
        : "";

      try {
        var resp = await searchGraphMessages(filter_text, this.from_starter);

        // Check if request was aborted
        if (this.folderFetchController && this.folderFetchController.signal.aborted) {
          return;
        }

        if (resp && resp.value && resp.value[0] && resp.value[0].hitsContainers && resp.value[0].hitsContainers[0]) {
          this.count_all_emails = resp.value[0].hitsContainers[0].total || 0;
          const response_mapped_init = resp.value
            .flatMap(p => p.hitsContainers)
            .flatMap(p => p.hits || []);
          const temp_arr = mapSearchApiResponse(response_mapped_init);

          // Append results for pagination (from_starter > 0) or replace for initial load
          if (this.from_starter > 0) {
            this.retrieved_email_array.push(...temp_arr);
          } else {
            this.retrieved_email_array = temp_arr;
          }
          this.filterEmails();
          this.from_starter += this.take_number;
        } else {
          this.retrieved_email_array = [];
          this.filtered_email_array = [];
          this.count_all_emails = 0;
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.$toast.error(this.$t('components.email.main.search_error'));
          this.retrieved_email_array = [];
          this.filtered_email_array = [];
        }
      } finally {
        this.loading_flag = false;
      }
    },
    isAnyClassVisible(classname) {
      const dialogs = document.querySelectorAll("."+classname);
      let flag_dialogs = false;
      for (let i = 0; i < dialogs.length; i++) {
        let single_dialog = dialogs[i];
        if (getComputedStyle(single_dialog).display !== "none") {
          flag_dialogs = true;
        }
      }
      return flag_dialogs;
    },
    estimatePageCount(email) {
      if (!email || !email.body) return 0;
      
      // Try to get actual rendered dimensions from A4 measurement div
      const a4Div = this.$refs.a4Measurement;
      if (a4Div) {
        const height = a4Div.offsetHeight * 0.75;
        const width = a4Div.offsetWidth * 0.75;

        // A4 dimensions in pixels (at 75% zoom)
        const a4Height = 1123; // 297mm at 96 DPI * 0.75
        const a4Width = 794;  // 210mm at 96 DPI * 0.75
        
        // Calculate pages based on height
        const pagesByHeight = Math.ceil(height / a4Height);
        
        // Calculate pages based on width (if content is wider than A4)
        const pagesByWidth = width > a4Width ? Math.ceil(width / a4Width) : 1;
        
        // Use the larger of the two calculations
        const estimatedPages = Math.max(pagesByHeight, pagesByWidth);
        
        // Add attachment count
        const attachmentCount = email.attachments ? email.attachments.length : 0;
        
        return Math.max(1, estimatedPages + attachmentCount);
      }
      
      // Fallback to character-based calculation if we can't get dimensions
      const bodyText = email.body.content || '';
      const isHTML = /<[a-z][\s\S]*>/i.test(bodyText);
      
      let charCount;
      if (isHTML) {
        const textOnly = bodyText.replace(/<[^>]*>/g, '');
        const htmlTags = bodyText.match(/<[^>]*>/g) || [];
        const textCharCount = textOnly.length;
        const htmlOverhead = htmlTags.length * 50;
        charCount = textCharCount + htmlOverhead;
      } else {
        charCount = bodyText.length;
      }
      
      const charsPerPage = 3000;
      const attachmentCount = email.attachments ? email.attachments.length : 0;
      const estimatedPages = Math.ceil(charCount / charsPerPage) + attachmentCount;
      
      return Math.max(1, estimatedPages);
    },
  },
  mounted() {
    this.switchFolder(this.selected_folder);
    // setTimeout(() => {
    //   /**
    //    * This is the listener method that is put up so the modal can be closed when user clicks outside the central class.
    //    */
    //   document.addEventListener("click", (event) => {
    //     const popUpMail = document.querySelector(".pop-up-mail"); //Main central class
    //     const dialogs_visible = this.isAnyClassVisible("v-dialog");
    //     const picker_visible = this.isAnyClassVisible("menuable__content__active");
    //     const loader_visible = this.isAnyClassVisible("main-blur-spinner")



    //     console.log("Is containing target", event.target, popUpMail)


    //     console.log(popUpMail.contains(event.target),picker_visible, dialogs_visible);

    //     // Check if the clicked element is outside the .pop-up-mail
    //     if (!popUpMail.contains(event.target) && !picker_visible && !dialogs_visible && !loader_visible) {
    //       //If it is clicked on, and the class isn't included inside, then we can close it.
    //       // Call your function here
    //       this.$emit("close");
    //     }
    //   });
    // }, 500);
  },
};
</script>

<style>
.page-count-info {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: #f5f5f5;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  color: #666;
}

.page-count-line {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.page-count-dropdown {
  padding: 2px 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  font-size: 14px;
  color: #333;
  width: 50px;
  text-align: center;
}

.page-count-dropdown:focus {
  outline: none;
  border-color: #5656d8;
}
.a4-measurement {
  position: absolute;
  visibility: hidden;
  width: 794px; /* A4 width in pixels at 96 DPI */
  padding: 20px;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
  font-size: 12pt;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
